// export default HierarchyView;
import { GitBranch, ChevronDown, ChevronRight } from "lucide-react";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import PersonCard from "../common/PersonCard"; // <-- IMPORT the common component

// The local HierarchyPersonCard component has been REMOVED

const HierarchyNode = ({ node }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const hasChildren = node.children && node.children.length > 0;

  return (
    <div className="hierarchy-node">
      <div
        onClick={() => hasChildren && setIsExpanded(!isExpanded)}
        className={hasChildren ? "clickable-node" : ""}
      >
        {/* Use the common PersonCard here, passing the necessary props */}
        <PersonCard personData={node} isHierarchyNode={true}>
          {hasChildren && (
            <span className="toggle-icon">
              {isExpanded ? (
                <ChevronDown size={18} />
              ) : (
                <ChevronRight size={18} />
              )}
            </span>
          )}
        </PersonCard>
      </div>
      <AnimatePresence>
        {isExpanded && hasChildren && (
          <motion.div
            className="child-container"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            {node.children.map((child, index) => (
              <HierarchyNode key={child._unique_id || index} node={child} />
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const HierarchyView = ({ selectedDept }) => {
  if (!selectedDept) {
    return (
      <div className="placeholder-container">
        <GitBranch size={48} className="placeholder-icon" />
        <p className="placeholder-text">Select a department</p>
        <p>Choose a department from the sidebar to view its hierarchy.</p>
      </div>
    );
  }
  return (
    <>
    <div className="org_chart_wrapper">
      <h2 className="panel-title-org" style={{paddingLeft:'20px'}}>
        {selectedDept.name} Department Hierarchy
      </h2>
      <div className="hierarchy-scroll-container">
        <div className="employee-list">
          {(selectedDept.children || []).map((p, idx) => (
            <HierarchyNode key={p._unique_id || idx} node={p} />
          ))}
        </div>
      </div>
      </div>
    </>
  );
};

export default HierarchyView;
